import { Injectable } from '@angular/core';
import { SalesforceService } from './shared/salesforce.service';
import { ZendeskService } from './shared/zendesk.service';
import { HttpClient } from '@angular/common/http';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { API_URL_COMPANIES } from 'src/app/shared/services/basic.service';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';
import { CrmAccountLinked } from './shared/crm-account-linked.model';
import { CrmOrganization } from './shared/crm-organization.model';
import { CRMType } from 'src/app/user-profile/shared/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CrmOrganizationsService {
  private all = [this.salesforceService, this.zendeskService];
  constructor(
    private salesforceService: SalesforceService,
    private zendeskService: ZendeskService,
    private httpClient: HttpClient,
    private alcmeonContextService: AlcmeonContextService,
    private errorHandlingService: ErrorHandlingService
  ) {}

  getStrategy(crmType: CRMType) {
    return this.all.find(s => s.getTypeString() === crmType);
  }

  linkSiteToOrganization(organizationId: number, accountLinkedId: number) {
    return this.httpClient
      .post<CrmAccountLinked>(
        `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/crm/organizations/${organizationId}/linked-sites`,
        { site_id: accountLinkedId }
      )
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  updateLinkedSite(organizationId: number, linkedSite: CrmAccountLinked) {
    return this.httpClient
      .put<any>(
        `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/crm/organizations/${organizationId}/linked-sites/${linkedSite.id}`,
        { linked_site: linkedSite }
      )
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  deleteLinkedSite(organizationId: number, id: number) {
    return this.httpClient
      .delete<string>(
        `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/crm/organizations/${organizationId}/linked-sites/${id}`
      )
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  // Authorization flow endpoints
  authorize(loginUrl: string, crmType: CRMType, crmOrganzationId?: number) {
    return this.httpClient
      .post<{ to_url: string }>(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/crm/authorize`, {
        loginUrl: loginUrl,
        crm_type: crmType,
        crm_organization_id: crmOrganzationId,
      })
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  updateOrganization(organization: CrmOrganization) {
    return this.httpClient
      .put<any>(
        `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/crm/organizations/${organization.id}`,
        organization
      )
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  deleteOrganization(organizationId: number) {
    return this.httpClient
      .delete<string>(
        `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/crm/organizations/${organizationId}`
      )
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  getOrganizationsList(crmType?: CRMType): Observable<CrmOrganization[]> {
    const queryParams = crmType ? { crm_type: crmType } : {};

    return this.httpClient
      .get<CrmOrganization[]>(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/crm/organizations`, {
        params: queryParams,
      })
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }
}
